import { useBattleCardsStore } from 'store/battlecards.store';

import { DisplayStyle } from 'components/common/ToggleView/ToggleView';

import ColumnsBoard from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/ColumnsBoard/ColumnsBoard';

export const ColumnsBoardWrapper = (props) => {
    const displayStyle = useBattleCardsStore((state) => state.displayStyle);
    if (displayStyle === DisplayStyle.COLUMNS) {
        return <ColumnsBoard {...props} />;
    } else {
        return null;
    }
};
